import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CommMatrixTypeReducer } from '../reducers';

export const selectCommMatrixTypeFeature = createFeatureSelector<CommMatrixTypeReducer.CommMatrixTypeState>(CommMatrixTypeReducer.featureName);

export const selectCommMatrixType = createSelector(selectCommMatrixTypeFeature, (state: CommMatrixTypeReducer.CommMatrixTypeState) => state.item);
